import { ManageSectionImage } from "../images/png/icons";
import "../../scss/freelancing-guide-styling-components/manage-section.style.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LOCALES } from "../../../common/constants";
import { getItem } from "../../helper/localstorage.helper";

const ManageSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const language = getItem("i18nextLng");

  const handleReadMoreClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(language === LOCALES.EN_US ? `/freelance-consultant-salary-invoice-without-a-company?lang=${LOCALES.EN_US}` : `/frilans-konsult-lon-fakturera-utan-foretag?lang=${LOCALES.SV_SE}`);
  };


  return (
    <div className="manage-section">
      <div className="left-col">
        <img src={ManageSectionImage} alt="Manage Your Time and Finances" />
      </div>
      <div className="right-col">
        <div className="header">
          <h1>{t("MANAGE_TITLE")}</h1>
          <p dangerouslySetInnerHTML={{ __html: t("MANAGE_DESC_1") }} />
        </div>
        <p className="strong-text">
          <strong>{t("MANAGE_DESC_2")}</strong>
        </p>
        <button className="readmore" onClick={handleReadMoreClick}>{t("READ_MORE")}</button>
      </div>
    </div>
  );
};

export default ManageSection;
